import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { ArticleImage } from "@/components/ArticleImage";

function splitSections(content) {
  const lines = content.split("\n");
  const intro = [];
  const sections = [];
  let current = null;
  for (const line of lines) {
    if (line.startsWith("## ") && !line.startsWith("### ")) {
      if (current) sections.push(current);
      current = { heading: line, body: [] };
    } else if (current) {
      current.body.push(line);
    } else {
      intro.push(line);
    }
  }
  if (current) sections.push(current);
  return { intro: intro.join("\n"), sections };
}

export function RichArticle({ content, images = [] }) {
  const hero = images.find((image) => image.role === "hero");
  const sectionImages = [
    images.find((image) => image.role === "section-1"),
    images.find((image) => image.role === "section-2"),
  ];
  const { intro, sections } = splitSections(content);
  return <article className="rich-article" data-testid="generated-rich-text">
    <ArticleImage image={hero} hero/>
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{intro}</ReactMarkdown>
    {sections.map((section, index) => <section className="rich-article-section" key={`${section.heading}-${index}`}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{section.heading}</ReactMarkdown>
      <ArticleImage image={sectionImages[index]}/>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{section.body.join("\n")}</ReactMarkdown>
    </section>)}
  </article>;
}